import React from 'react';

import useApi from './useApi';

const BASE_URL = '/order-status';

export const useOrderStatus = () => {
  const { get } = useApi();

  const list = React.useCallback(
    async status => get(`${BASE_URL}?status=${status}`),
    [get],
  );

  return { list };
};

export default useOrderStatus;
